'use strict';

exports.__esModule = true;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../styles/js/_colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = _styledComponents2.default.button.withConfig({
  displayName: 'Button.styled__Button'
})(['display:flex;align-items:center;justify-content:center;width:36px;height:36px;margin:5px;color:', ';cursor:pointer;background-color:', ';border:1px solid ', ';border-radius:2px;svg{margin:5px 0 0 0;width:1.25em;height:1.25em;max-height:20px;max-width:20px;path{fill:', ';}}& *{cursor:pointer;text-decoration:none;}& > input{margin:0;}&:focus{outline:0;}&:active{border-width:2px;}&:disabled{color:', ';cursor:not-allowed;border-color:', ';& svg{path{fill:', ';}}& *{cursor:not-allowed;}}'], _colors2.default.black, _colors2.default.white, _colors2.default.grayLight, _colors2.default.black, _colors2.default.grayLight, _colors2.default.cardBorderColor, _colors2.default.grayLight);

exports.default = Button;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/HeaderButton/Button.styled.js
// module id = 2226
// module chunks = 14